// src/ui/theme.js

export const THEME = {
  /* ===== Base ===== */
  bg: "#0E1F26",
  panel: "rgba(255,255,255,0.05)",
  panel2: "rgba(255,255,255,0.08)",
  border: "rgba(255,255,255,0.10)",
  shadow: "0 8px 20px rgba(0,0,0,0.28)",

  radius: 16,
  radiusPill: 999,

  /* ===== Typography ===== */
  fontFamily: `"Inter", "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif`,
  text: "rgba(255,255,255,0.94)",
  muted: "rgba(255,255,255,0.65)",

  /* ===== Brand ===== */
  brand: "#0a3542",
  brandSoft: "rgba(10,53,66,0.25)",
  brandAccent: "#1E6A82",

  /* ===== Status ===== */
  ok: "#2FBF9E",
  warn: "#F4B860",
  alert: "#E5533D",

  /* ===== Charts ===== */
  chartPrimary: "#1E6A82",
  chartSecondary: "#2FBF9E",
  chartTertiary: "#8FBFCC",
};

/* =========================
   Safe-area helpers
   (usa CSS vars definidas no index.css)
========================= */

export const SAFE = {
  top: "var(--sat, 0px)",
  bottom: "var(--sab, 0px)",
  left: "var(--sal, 0px)",
  right: "var(--sar, 0px)",
};

/* =========================
   App background
========================= */

export function appBackgroundStyle(extra = {}) {
  return {
    minHeight: "100dvh",
    background: THEME.bg,   // ✅ simples
    color: THEME.text,
    ...extra,
  };
}

/* =========================
   Screen container (respeita bottom bar)
========================= */

export function screenStyle(extra = {}) {
  return {
    width: "100%",
    maxWidth: 980,
    margin: "0 auto",

    paddingLeft: 12,
    paddingRight: 12,

    /* Safe-area topo */
    // paddingTop: `calc(12px + ${SAFE.top})`,
    // paddingTop: SAFE.top,   // ✅ só safe-area
    paddingTop: 0,   // ✅ só safe-area

    /* Safe-area bottom + altura da bottom bar */
    // paddingBottom: `calc(12px + ${SAFE.bottom} + 74px)`,
    paddingBottom: `calc(12px + env(safe-area-inset-bottom, 0px) + var(--bottomTabsH, 44px) + 12px)`,


    ...extra,
  };
}

/* =========================
   Bottom bar fixa (blur + safe-area)
========================= */

export function bottomBarStyle(extra = {}) {
  return {
    position: "fixed",
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 50,

    paddingBottom: SAFE.bottom,
    paddingLeft: SAFE.left,
    paddingRight: SAFE.right,

    background: "rgba(14,31,38,0.55)",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",

    borderTop: `1px solid ${THEME.border}`,
    ...extra,
  };
}

/* =========================
   Panels
========================= */

export function panelStyle(extra = {}) {
  return {
    background: THEME.panel,
    border: `1px solid ${THEME.border}`,
    borderRadius: THEME.radius,
    boxShadow: THEME.shadow,
    ...extra,
  };
}

/* =========================
   Buttons
========================= */

export function btnStyle(active = false, extra = {}) {
  return {
    padding: "9px 12px",
    borderRadius: THEME.radiusPill,
    border: `1px solid ${active ? "rgba(255,255,255,0.28)" : THEME.border}`,
    background: active ? "rgba(255,255,255,0.14)" : "rgba(255,255,255,0.06)",
    color: THEME.text,
    fontWeight: 900,
    letterSpacing: 0.2,
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    WebkitTapHighlightColor: "transparent",
    ...extra,
  };
}

/* =========================
   Status / tones
========================= */

export function toneStyle(tone, extra = {}) {
  if (tone === "ok")
    return {
      background: "rgba(52,211,153,0.14)",
      color: THEME.ok,
      border: "1px solid rgba(52,211,153,0.25)",
      ...extra,
    };

  if (tone === "warn")
    return {
      background: "rgba(251,191,36,0.14)",
      color: THEME.warn,
      border: "1px solid rgba(251,191,36,0.25)",
      ...extra,
    };

  if (tone === "alert")
    return {
      background: "rgba(251,113,133,0.14)",
      color: THEME.alert,
      border: "1px solid rgba(251,113,133,0.25)",
      ...extra,
    };

  return {
    background: "rgba(255,255,255,0.08)",
    color: THEME.muted,
    border: `1px solid ${THEME.border}`,
    ...extra,
  };
}

export function appViewportStyle(extra = {}) {
  return {
    /* ✅ NÃO trava em 100dvh, NÃO cria scroll interno */
    minHeight: "100%",
    background: THEME.bg,
    color: THEME.text,
    ...extra,
  };
}